import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ShopItem {
  id: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  category: 'salary_cap' | 'features' | 'upgrades';
  metadata?: {
    salaryCapIncrease?: number; // in millions
    featureType?: string;
    [key: string]: unknown;
  };
}

export interface CartItem {
  item: ShopItem;
  quantity: number;
}

interface ShoppingCartState {
  items: CartItem[];
  addItem: (item: ShopItem, quantity?: number) => void;
  removeItem: (itemId: string) => void;
  updateQuantity: (itemId: string, quantity: number) => void;
  clearCart: () => void;
  getTotalPrice: () => number;
  getItemCount: () => number;
  hasSalaryCapItem: () => boolean;
  getSalaryCapItem: () => CartItem | undefined;
}

export const useShoppingCartStore = create<ShoppingCartState>()(
  persist(
    (set, get) => ({
      items: [],
      addItem: (item: ShopItem, quantity = 1) => {
        set((state) => {
          const existingItem = state.items.find((cartItem) => cartItem.item.id === item.id);
          if (existingItem) {
            // If item already in cart, update quantity
            return {
              items: state.items.map((cartItem) =>
                cartItem.item.id === item.id
                  ? { ...cartItem, quantity: cartItem.quantity + quantity }
                  : cartItem
              ),
            };
          }
          // Otherwise, add new item
          return {
            items: [...state.items, { item, quantity }],
          };
        });
      },
      removeItem: (itemId: string) => {
        set((state) => ({
          items: state.items.filter((cartItem) => cartItem.item.id !== itemId),
        }));
      },
      updateQuantity: (itemId: string, quantity: number) => {
        if (quantity <= 0) {
          get().removeItem(itemId);
          return;
        }
        set((state) => ({
          items: state.items.map((cartItem) =>
            cartItem.item.id === itemId
              ? { ...cartItem, quantity }
              : cartItem
          ),
        }));
      },
      clearCart: () => {
        set({ items: [] });
      },
      getTotalPrice: () => {
        return get().items.reduce((total, cartItem) => {
          return total + cartItem.item.price * cartItem.quantity;
        }, 0);
      },
      getItemCount: () => {
        return get().items.reduce((total, cartItem) => {
          return total + cartItem.quantity;
        }, 0);
      },
      hasSalaryCapItem: () => {
        console.log('hasSalaryCapItem', get().items,  get().items.some((cartItem) => cartItem.item.name.includes('Increase to')));
        return get().items.some((cartItem) => cartItem.item.name.includes('Increase to'));
      },
      getSalaryCapItem: () => {
        return get().items.find((cartItem) => cartItem.item.name.includes('Increase to'));
      },
    }),
    {
      name: 'shopping-cart-storage',
      partialize: (state) => ({ items: state.items }),
    }
  )
);

